/* tslint:disable */
/* eslint-disable */
/**
 * Ster.nl API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SterWebsiteModelPriceCompareCalculateResultForOperator
 */
export interface SterWebsiteModelPriceCompareCalculateResultForOperator {
  /**
   *
   * @type {number}
   * @memberof SterWebsiteModelPriceCompareCalculateResultForOperator
   */
  onePlusReachPercentage: number;
  /**
   *
   * @type {number}
   * @memberof SterWebsiteModelPriceCompareCalculateResultForOperator
   */
  onePlusReachAbsolute: number;
  /**
   *
   * @type {number}
   * @memberof SterWebsiteModelPriceCompareCalculateResultForOperator
   */
  gcf: number;
  /**
   *
   * @type {number}
   * @memberof SterWebsiteModelPriceCompareCalculateResultForOperator
   */
  grps: number;
  /**
   *
   * @type {number}
   * @memberof SterWebsiteModelPriceCompareCalculateResultForOperator
   */
  pricePerGrp: number;
  /**
   *
   * @type {number}
   * @memberof SterWebsiteModelPriceCompareCalculateResultForOperator
   */
  campaignId: number;
}

export function SterWebsiteModelPriceCompareCalculateResultForOperatorFromJSON(
  json: any
): SterWebsiteModelPriceCompareCalculateResultForOperator {
  return SterWebsiteModelPriceCompareCalculateResultForOperatorFromJSONTyped(
    json,
    false
  );
}

export function SterWebsiteModelPriceCompareCalculateResultForOperatorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SterWebsiteModelPriceCompareCalculateResultForOperator {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    onePlusReachPercentage: json["onePlusReachPercentage"],
    onePlusReachAbsolute: json["onePlusReachAbsolute"],
    gcf: json["gcf"],
    grps: json["grps"],
    pricePerGrp: json["pricePerGrp"],
    campaignId: json["campaignId"],
  };
}

export function SterWebsiteModelPriceCompareCalculateResultForOperatorToJSON(
  value?: SterWebsiteModelPriceCompareCalculateResultForOperator | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    onePlusReachPercentage: value.onePlusReachPercentage,
    onePlusReachAbsolute: value.onePlusReachAbsolute,
    gcf: value.gcf,
    grps: value.grps,
    pricePerGrp: value.pricePerGrp,
    campaignId: value.campaignId,
  };
}
